<template>
  <v-app-bar
    v-if="type != null"
    color="#ffffff"
    class="border-bottom"
    app
    grow
    flat
  >
    <v-btn v-if="type == 'back'" icon @click="getBack">
      <v-icon>arrow_back</v-icon>
    </v-btn>
    <router-link v-else-if="type == 'default'" :to="{ name: 'Home' }">
      <v-img
        class="mr-4"
        src="../assets/logo.svg"
        max-height="32"
        max-width="32"
        contain
      ></v-img>
    </router-link>
    <v-toolbar-title class="font-weight-bold mr-md-4 d-none d-md-flex"
      >Eventversity
    </v-toolbar-title>
    <v-toolbar-title
      class="font-weight-bold mr-md-4 d-xl-none d-lg-none d-md-none"
      >{{ titlePage }}
    </v-toolbar-title>

    <router-link
      active-class
      v-for="item in menuItems"
      :key="item.title"
      :to="item.path"
      class="nav-link mx-4 d-none d-md-flex body-1 font-weight-bold"
    >
      {{ item.title }}
    </router-link>

    <v-spacer></v-spacer>

    <v-btn
      target="_blank"
      link
      :href="gotoApp"
      elevation="0"
      class="d-none d-md-flex"
      ><v-icon>add</v-icon> <span class="ml-2">Buat Event</span></v-btn
    >

    <v-btn
      target="_blank"
      link
      :href="gotoApp"
      elevation="0"
      class="d-sm-flex d-md-none"
      icon
      ><v-icon>add</v-icon></v-btn
    >

    <router-link
      v-if="isLogged"
      active-class
      to="/my-account"
      class="nav-link mx-4 d-none d-md-flex body-1 font-weight-bold"
    >
      <span class="text-capitalize">Hi, {{ user.name }}</span>
      <v-avatar size="24px" class="ml-2">
        <img :src="user.avatar" />
      </v-avatar>
    </router-link>
    <router-link
      v-else
      active-class
      to="/login"
      class="nav-link mx-4 d-none d-md-flex body-1 font-weight-bold"
    >
      <v-btn color="primary" elevation="0">Login</v-btn>
    </router-link>
  </v-app-bar>
</template>

<script>
export default {
  name: 'AppBar',
  props: {
    titlePage: {
      default: 'Eventversity',
      type: String,
    },
    type: String,
  },
  data() {
    return {
      menuItems: [
        { title: 'Home', path: '/', icon: 'mdi-home' },
        { title: 'Explore', path: '/semua-event', icon: 'mdi-magnify' },
        { title: 'Articles', path: '/article', icon: 'mdi-magnify' },
        { title: 'My Ticket', path: '/my-ticket', icon: 'mdi-ticket' },
        { title: 'Bantuan', path: '/bantuan', icon: 'mdi-ticket' },
      ],
      isLogged: localStorage.getItem('isLogged'),
      user: JSON.parse(localStorage.getItem('user')),
      gotoApp: process.env.VUE_APP_DASHBOARD,
    };
  },
  mounted() {
    console.log(this.type);
  },
  methods: {
    getBack() {
      this.$router.go(-1);
    },
  },
};
</script>

<style scoped>
a,
.body-1 {
  text-decoration: none;
  font-family: 'Rubik', sans-serif !important;
}
.nav-link {
  color: #212121;
  font-family: 'Rubik', sans-serif !important;
}

.router-link-exact-active {
  color: #3a4be4 !important;
}

.v-toolbar__title {
  font-family: 'Rubik', sans-serif !important;
}
.router-link-exact-active {
  color: inherit;
}
.border-bottom {
  box-shadow: 0 2px 0px -4px rgba(0, 0, 0, 0.2),
    0 -6px 0px 0 rgba(0, 0, 0, 0.14), 0 1px 3px 0 rgba(0, 0, 0, 0.12) !important;
}
</style>
